import axios from "axios";
import { LOCAL_STORAGE_KEY } from "./types";

class Auth {
  // const url = '/v1/auth?format=jwt';
  static login(username, password) {
    const url = process.env.REACT_APP_LOGIN_API;
    const data = {
      referrer: "teletracnavman.com",
      username,
      password
    };

    return axios.post(url, data).then(response => {
      Auth.setToken(response.data.auth.token)
    });
  }

  static getJWT() {
    return sessionStorage.getItem(LOCAL_STORAGE_KEY);
  }

  static logout() {
    Auth.removeToken();
  }

  static isLoggedIn() {
    return !!Auth.getJWT();
  }

  static setToken(token) {
    this.token = token;
    // Remove old localStorage token on login.
    localStorage.removeItem(LOCAL_STORAGE_KEY);
    sessionStorage.setItem(LOCAL_STORAGE_KEY, token);
  }

  static removeToken() {
    this.token = null;
    // Leave localStorage removal in until all old tokens have gone.
    localStorage.removeItem(LOCAL_STORAGE_KEY);
    sessionStorage.removeItem(LOCAL_STORAGE_KEY);
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/Auth.js